import React from "react";
import Reveal from "../Reveal";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white py-28 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="overline">About KDM</p>
          <h2
            data-testid="about-heading"
            className="font-serif font-medium text-4xl lg:text-5xl mt-6 leading-[1.05] tracking-tight"
          >
            Building tomorrow,
            <br />
            <span className="italic text-gold">together.</span>
          </h2>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 space-y-8 max-w-2xl">
          <Reveal>
            <p className="text-lg text-[--kdm-ink] leading-relaxed">
              For more than fifteen years, KDM Group has quietly operated at the
              intersection of Italian craftsmanship, Sri Lankan ambition and American
              scale — turning cross-border opportunity into long-term, generational value.
            </p>
          </Reveal>

          <Reveal delay={120}>
            <p className="text-base text-[--kdm-ink-soft] leading-relaxed">
              From the Blue Whale Resort in Kalpitiya to vertical knit production in Dhaka,
              from a Milan-based brokerage to back-office bridges across the United States —
              every venture we operate is built on a foundation of financial stability,
              international standards and diversified asset management.
            </p>
          </Reveal>

          <Reveal delay={220}>
            <div className="grid sm:grid-cols-3 gap-6 pt-8 border-t border-[--kdm-line]">
              {[
                { k: "Diverse", v: "Industries" },
                { k: "Global", v: "Partnerships" },
                { k: "Sustainable", v: "Growth" },
              ].map((p) => (
                <div key={p.k}>
                  <p className="font-serif text-xl text-[--kdm-ink]">{p.k}</p>
                  <p className="overline mt-2 !text-[--kdm-ink-soft] !font-medium">{p.v}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
